import { BrowserRouter, Routes, Route } from "react-router-dom";

import Landing from "../pages/Landing/Landing";
import Empresa from "../pages/Empresa/Empresa";
import Grupo from "../pages/Grupo/Grupo";
import Nosotros from "../pages/Nosotros/Nosotros";
import ScrollToTop from "../components/Hooks/ScrollToTop";

const AppRoutes = () => {
    return (
        <BrowserRouter>

            <ScrollToTop />

            <Routes>

                <Route path="/" element={<Landing />} />

                <Route path="/empresa" element={<Empresa />} />

                <Route path="/nosotros" element={<Nosotros />} />

                <Route path="/grupo" element={<Grupo />} />

            </Routes>
        </BrowserRouter>
    );
};

export default AppRoutes;
